module.exports = __webpack_public_path__ + "img/img7.13007802.jpg";